import { Application } from "../interfaces";
import { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { UserSecurity } from "../types";
import { useMsal } from "@azure/msal-react";
import * as Types from "../clients/ApiEndpoint.types";

export const useProfile = <T,>(application: Application): T | undefined => {
    const [userStatus, setuserStatus] = useState<T>();
    const { accounts } = useMsal();    
    const userEmail = accounts[0] && accounts[0].username;
   // const userClaimsObjectId = accounts[0].homeAccountId.split(".")[0];
    const getUserStatusAsync = async () => {
       // const userSecurity = new UserSecurity(userEmail, userClaimsObjectId);
        // const userSecurityJson = JSON.stringify(userSecurity);
        // const options = {
        //     method: "POST",
        //     body: userSecurityJson,
        //     headers: { "Content-Type": "application/json" }
        // };
        const response = await fetch(`${application.baseUrl}/authentication/GetUserSecurityByEmail/${userEmail}`)
        let output: Types.FetchResponse<any> = response;
        output.data = await response.json();
        const jwtResponse = output.data;                                                
        setuserStatus(jwtResponse);
    }
    useEffect(() => {
        if (!userStatus) trackPromise(getUserStatusAsync());
    }, []);
    return userStatus;
};

export default useProfile;